import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DataTransferService } from '../../../services/raintree/Transmission/data-transfer.service';
import { RaintreeResponse } from '../../../services/raintree/interfaces/raintree-response';
import { AuthTransmissionService } from '../../../services/raintree/Transmission/auth-transmission.service';
import { SnackbarService } from '../../../services/common/snackbar.service';

@Component({
  selector: 'app-login-role-merge',
  standalone: true,
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    MatAutocompleteModule,
  ],
  templateUrl: './login-role-merge.component.html',
  styleUrl: './login-role-merge.component.scss',
})
export class LoginRoleMergeComponent {
  constructor(
    private activateRoute: ActivatedRoute,
    private dataService: DataTransferService,
    private _authTransmissionService: AuthTransmissionService,
    private snackbar: SnackbarService,
    private router: Router
  ) {}
  email_id: any;
  role_name: any;
  member_code: any;
  familyCode: any;
  sessionId: any;
  largeData: any;
  array: any = [];
  emailArray: any = [];
  email = new FormControl('');
  length: number = 0;
  details: any;
  linkedAccounts: any;
 
  ngOnInit() {
    this.details = JSON.parse(localStorage.getItem('linkedAccounts') || 'null');
    this.email_id = localStorage.getItem('email_id');
    this.role_name = localStorage.getItem('role_name');
    this.member_code = localStorage.getItem('member_code');
    this.familyCode = localStorage.getItem('familyCode');
    this.sessionId = localStorage.getItem('sessionId');

    // if (
    //   !this.details ||
    //   !this.email_id ||
    //   !this.role_name ||
    //   !this.familyCode ||
    //   !this.member_code ||
    //   !this.sessionId
    // ) {
    //   this.router.navigate(['/login']);
    // }
  }
  
  selectedMail: any;
  getMemKey(email: any) {
    this.selectedMail = email;
  }
  emailFormControlValue: any;
  APIcall() {
    let loginFormPayload = {
      sessionId: this.sessionId,
      verifiedEmail: this.email.value,
    };

    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: (response: RaintreeResponse) => {
        this.emailFormControlValue = this.email.value;

        localStorage.setItem('maskedEmail', response['data'].target);
        localStorage.setItem('sessionId', response['data'].sessionId);
        localStorage.setItem('verifiedEmail', this.emailFormControlValue);
        localStorage.setItem('primaryEmail', this.selectedMail);
        this.router.navigate(['/login-email-authentication-code']);
      },
      error: (error) => {
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
}
